module.exports = __webpack_public_path__ + "static/media/PQR_Beton_logo_fond_blanc.78738fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PQR_Beton_logo_fond_blanc.svg
// module id = 293
// module chunks = 0